import { createAsyncThunk } from "@reduxjs/toolkit";
import { showHideLoader } from "../common/common.slice";
import { authorizedUsersService } from "../../services/authorizedUsers.service";

    // Create Customer User Action
    const createCustomerUserAction = createAsyncThunk(
        'authorizedUsersSlice/createCustomerUserAction', (payload: any, { dispatch, rejectWithValue }) => {
            dispatch(showHideLoader(true));
            return authorizedUsersService.createCustomerUserService(payload)
                .then((response: any) => {
                    dispatch(showHideLoader(false));
                    return response
                })
                .catch((error: { response: unknown; }) => {
                    dispatch(showHideLoader(false));
                    return rejectWithValue(error?.response);
                })
        }
    )

    // Get Client Details Service
    const getCustomerUsersAction = createAsyncThunk(
        'authorizedUsersSlice/getCustomerUsersAction', (payload: any, { dispatch, rejectWithValue }) => {
            dispatch(showHideLoader(true));
            return authorizedUsersService.getCustomerUserDetailsService(payload)
                .then((response: any) => {
                    dispatch(showHideLoader(false));
                    return response
                })
                .catch((error: { response: unknown; }) => {
                    dispatch(showHideLoader(false));
                    return rejectWithValue(error?.response);
                })
        }
    )

    // Remove Customer User Action
    const removeCustomerUserAction = createAsyncThunk(
        'authorizedUsersSlice/removeCustomerUserAction', (payload: any, { dispatch, rejectWithValue }) => {
            dispatch(showHideLoader(true));
            return authorizedUsersService.removeCustomerUserService(payload)
                .then((response: any) => {
                    dispatch(showHideLoader(false));
                    return response
                })
                .catch((error: { response: unknown; }) => {
                    dispatch(showHideLoader(false));
                    return rejectWithValue(error?.response);
                })
        }
    )

export const authorizedUserAction = {
    createCustomerUserAction,
    getCustomerUsersAction,
    removeCustomerUserAction
}